<template>
  <vs-row vs-type="flex" vs-w="12" id="RawMaterialConsumptionLossPage">
    <vs-row vs-type="flex" vs-w="12">
      <vs-row vs-type="flex" vs-w="12" class="mb-1">
        <global-filter ref="filterer" :tableOptions="tableOptions" :filterOptions="filterOptions"
                       :filterChips="filterChips" :filterOptionNames="filterOptionNames" :isActive="isFilterActive"
                       @saveOptions="saveOptions" @close="isFilterActive = false;"/>
        <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between">
          <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="flex-start">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Detaylı Filtereleme" position="top">
                  <vs-button @click="isFilterActive = !isFilterActive;"
                             class="panel-action text-warning xlarge-button panel-action-box-shadow" color="transparent"
                             icon-pack="pickicon" icon="icon-pick-filter">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Excel Export" position="top">
                  <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                             color="transparent" icon-pack="feather" icon="icon-download">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col vs-type="flex" class="w-auto" vs-align="center">
                <vx-tooltip :text="showBranch ? 'Şube Göster (Aktif)' : 'Şube Göster (Pasif)'" position="top" style="display: flex; align-items: center; height: 100%;">
                  <span class="text-dark weight-600 mr-1 ml-2" style="white-space: nowrap; font-size: 11px;">Şube Göster</span>
                  <vs-switch color="success" v-model="showBranch" class="ml-1"/>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col id="filter-chips" vs-type="flex">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
              <vs-button id="clearFilterButton" v-if="filterChips.length > 0" @click="clearFilter"
                         class="mr-2 bg-white text-danger panel-action-box-shadow" icon-pack="feather" icon="icon-slash"
                         radius
                         color="transparent"/>
              <vs-col vs-type="flex" class="w-auto" v-for="(chip,index) in filterChips" :key="index">
                <vs-chip color="white" class="panel-action-box-shadow px-1" @click="removeFilter(chip.col,index)"
                         v-show="chip.value != '' " closable>
                  <vs-row vs-tpye="flex" vs-w="12">
                    <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                      <span class="bold text-xsmaller text-dark">
                        {{ chip.name + ' :' }}
                      </span>
                    </vs-col>
                    <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                      <span class="weight-600 italic text-xsmaller text-primary">
                        {{ chip.value }}
                      </span>
                    </vs-col>
                  </vs-row>
                </vs-chip>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col id="table-page-size" vs-type="flex" class="w-auto" vs-justify="flex-end">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" vs-w="3.75">
                <vx-tooltip title="Yenile" :text="toRefreshString + ' içinde yenilenecek.'" position="top">
                  <vs-button @click="refreshNow()"
                             class="panel-action text-primary xlarge-button panel-action-box-shadow" color="transparent"
                             icon-pack="feather" icon="icon-refresh-ccw">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" v-if="reportData && reportData.length > 0">
      <raw-materials-min @onSetSortingOptions="setSortingOptions" :stop="true" :reportData="reportData"
                         :tableOptions="tableOptions" :sortingHeadIcon="sortingHeadIcon"
                         :hideBranch="!showBranch"
                         :orderBy="tableOptions.reportByProp ? tableOptions.reportByProp.id : 0 "/>
    </vs-row>
  </vs-row>
</template>

<script>
import {getSortDirections} from "@/model/constants/dashboardModels.js";
import GlobalFilter from "../../GlobalFilter";
import RawMaterialsMin from "../RawMaterialConsumption/RawMaterialConsumptionMin";
import {
  GetRawMaterialConsumptionSumForLoss,
  GetRawMaterialConsumptionSumForLossForDealer,
  GetRawMaterialConsumptionSumsExcelForLoss,
  GetRawMaterialConsumptionSumsExcelForLossForDealer
} from "@/api/Reports.js";

export default {
  components: {
    GlobalFilter,
    RawMaterialsMin
  },
  data() {
    return {
      tableOptions: {},
      reportData: null,
      toRefresh: 5 * 60,
      isFilterActive: false,
      filterOptions: ["branch", "defaultTimeRange", "dateRange", "rawMaterial", "variant","rawMaterialCategory"],
      filterOptionNames: ["Şube", "Zaman Aralığı", "Tarih", "Hammadde", "Varyant","Kategori"],
      filterChips: [],
      directions: getSortDirections(),
      sortingHeadIcon: "icon-arrow-up",
      sortingHeadIconBool: 2,
      showBranch: false
    }
  },
  computed: {
    toRefreshString() {
      if (this.toRefresh < 60) return this.toRefresh + " Saniye";
      if (this.toRefresh == 60) return "1 Dakika";
      let min = this.toRefresh / 60;
      let sec = this.toRefresh % 60;
      return (min | 0) + " Dakika " + sec + " Saniye";
    },
  },
  mounted() {
    this.doRefresh();
    this.clearFilter();
  },
  methods: {
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
    getExcel() {
      const params = { ...this.tableOptions, ShowBranch: this.showBranch };
      if (this.$isRegionalCenterBranch()) {
        GetRawMaterialConsumptionSumsExcelForLossForDealer(params).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Zaiyat Hammadde Tüketim Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
      } else {
        GetRawMaterialConsumptionSumsExcelForLoss(params).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Zaiyat Hammadde Tüketim Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
      }

    },
    refreshNow() {
      this.toRefresh = 5 * 60;
      this.GetRawMaterialConsumptionSumForLoss();
    },
    doRefresh() {
      let vm = this;
      setInterval(function () {
        vm.toRefresh--;
      }, 1000);
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    removeFilter(col, index) {
      if (col === "branch") this.tableOptions[col] = (this.$isCenterBranch() || this.$isRegionalCenterBranch()) ? null : this.$currentUser.branch;
      else this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    clearFilter() {
      this.tableOptions = {
        dateRange: {
          startDate: null,
          endDate: null
        },
        sortBy: 'rawMaterial.Name',
        branch: (this.$isCenterBranch() || this.$isRegionalCenterBranch()) ? null : this.$currentUser.branch,
        rawMaterial: null,
        defaultTimeRange: this.$now().getHours() >= 0 && this.$now().getHours() <= 2 ? {
          name: "Yesterday",
          id: 0,
          dName: "Dün"
        } : {
          name: "Today",
          id: 1,
          dName: "Bugün"
        },
        sortDirection: this.directions[0]
      };
      this.filterChips.length = 0;
    },
    GetRawMaterialConsumptionSumForLoss() {
      const params = { ...this.tableOptions, ShowBranch: this.showBranch };
      if (this.$isRegionalCenterBranch()) {
        GetRawMaterialConsumptionSumForLossForDealer(params).then(res => {
        if (res && res.status == 200) {
          this.reportData = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Rapor Hazırlanamadı"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası"
        });
      });
      } else {
        GetRawMaterialConsumptionSumForLoss(params).then(res => {
        if (res && res.status == 200) {
          this.reportData = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Rapor Hazırlanamadı"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası"
        });
      });
      }

    }
  },
  watch: {
    showBranch() {
      this.GetRawMaterialConsumptionSumForLoss();
    },
    sortingHeadIconBool(val) {
      switch (val) {
        case 1:
          this.tableOptions.sortDirection = null;
          break;
        case 2:
          this.tableOptions.sortDirection = this.directions[0];
          break;
        case 3:
          this.tableOptions.sortDirection = this.directions[1];
          break;
      }
    },
    toRefresh(val) {
      if (val != 0) return;
      this.GetRawMaterialConsumptionSumForLoss();
      this.toRefresh = 5 * 60;
    },
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.GetRawMaterialConsumptionSumForLoss();
        });
      }
    },
  }
}

</script>

<style>

</style>
